import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./i18n";

Sentry.init({
  dsn: "https://a887cac58a700ed9cc99daed8b1599b8@o4505832230748160.ingest.sentry.io/4506077676175360",
  enabled: !import.meta.env.DEV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
